// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprSimpleAawOpenConfig extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.simple.aaw_open_config";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSimpleAawOpenConfig {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "Configuració de privacitat i publicitat",
                "cs": "Nastavení ochrany soukromí a reklamy",
                "da": "Indstillinger for privatliv og reklamer",
                "de": "Datenschutz- und Werbeeinstellungen",
                "en": "Privacy and advertising settings",
                "es": "Configuración de privacidad y publicidad",
                "eu": "Pribatutasun eta publizitatearen ezarpenak",
                "fi": "Yksityisyys- ja mainosasetukset",
                "fr": "Paramètres de confidentialité et de publicité",
                "gl": "Configuración de privacidade e publicidade",
                "hi": "गोपनीयता और विज्ञापन सेटिंग्स",
                "hu": "Adatvédelmi és hirdetési beállítások",
                "it": "Impostazioni sulla privacy e sulla pubblicità",
                "nl": "Privacy- en advertentie-instellingen",
                "no": "Personvern- og annonseinnstillinger",
                "pl": "Ustawienia prywatności i reklam",
                "pt": "Configurações de privacidade e publicidade",
                "ro": "Setări de confidențialitate și publicitate",
                "ru": "Настройки конфиденциальности и рекламы",
                "sk": "Nastavenia ochrany osobných údajov a reklamy",
                "sv": "Sekretess- och annonsinställningar",
                "tr": "Gizlilik ve reklam ayarları",
                "pt-BR": "Configurações de privacidade e publicidade"
            },
            "defecto": "Privacy and advertising settings"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
